import { render } from "./MCard.vue?vue&type=template&id=2072e963"
import script from "./MCard.vue?vue&type=script&lang=js"
export * from "./MCard.vue?vue&type=script&lang=js"

import "./MCard.vue?vue&type=style&index=0&id=2072e963&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__